// Presença: com o jogo aberto, o aparelho avisa a API a cada 30 s (online nos últimos 2 minutos, visto há). A resposta
// traz o que a navegação e o sino mostram: os pedidos de amizade recebidos e as notificações não lidas, e o chamado
// para a mesa dos últimos 2 minutos, que vira a faixa com Entrar.
import { useSyncExternalStore } from 'react';
import { api } from './api.ts';
import { config } from './config.ts';
import type { Sessao } from './conta.ts';

export interface ChamadoParaMesa { id: string; de: string; codigo: string; nome: string }
export interface SituacaoDoAparelho {
  pedidos: number;
  naoLidas: number;
  chamado: ChamadoParaMesa | null;
  apelidoRevisar?: boolean; // a moderação trocou o apelido: a pessoa escolhe outro antes de jogar
}
const INTERVALO_MS = 30_000;

let atual: SituacaoDoAparelho = { pedidos: 0, naoLidas: 0, chamado: null, apelidoRevisar: false };
let agora: (() => Promise<void>) | null = null;
const ouvintes = new Set<() => void>();

// Liga a presença da conta da aba; devolve a função que desliga. No modo local, o perfil vai junto (a API em memória
// não tem os perfis do banco).
export function iniciarPresenca(s: Sessao, perfil: { apelido: string; avatar: string | null }): () => void {
  let vivo = true;
  const avisar = async () => {
    try {
      const r = await api<SituacaoDoAparelho>(s, 'POST', '/presenca', config.authLocal ? { perfil } : {});
      if (!vivo) return;
      const chamado = r.chamado ?? null;
      const apelidoRevisar = !!r.apelidoRevisar;
      if (r.pedidos !== atual.pedidos || r.naoLidas !== atual.naoLidas || chamado?.id !== atual.chamado?.id || apelidoRevisar !== atual.apelidoRevisar) {
        atual = { pedidos: r.pedidos, naoLidas: r.naoLidas, chamado, apelidoRevisar };
        for (const f of ouvintes) f();
      }
    } catch { /* sem conexão: tenta de novo em 30 s */ }
  };
  agora = avisar;
  void avisar();
  const t = setInterval(() => { void avisar(); }, INTERVALO_MS);
  return () => { vivo = false; clearInterval(t); if (agora === avisar) agora = null; };
}

// O apelido novo foi aceito: libera o jogo sem esperar a próxima presença.
export function apelidoLiberado(): void { atual = { ...atual, apelidoRevisar: false }; for (const f of ouvintes) f(); }

// Pergunta de novo na hora (depois de aceitar um pedido ou de ler as notificações).
export function atualizarPresenca(): void { void agora?.(); }

// Só para os testes: a resposta da API como se tivesse chegado agora.
export function _definirParaTestes(s: SituacaoDoAparelho): void { atual = s; for (const f of ouvintes) f(); }

export function usePresenca(): SituacaoDoAparelho {
  return useSyncExternalStore((f) => { ouvintes.add(f); return () => ouvintes.delete(f); }, () => atual, () => atual);
}
